import { Injectable } from '@angular/core';

@Injectable()
export class ToastService {
    public showSuccess: (message?: string, title?: string, displayTimeMs?: number) => void;
    public showWarning: (message?: string, title?: string, displayTimeMs?: number) => void;
    public showError: (message?: string, title?: string, displayTimeMs?: number) => void;
    public clear: () => void;
}
